export default __webpack_public_path__ + "static/media/mrp.7dee7307.png";